//import React from "react";
import React, { useEffect, useState, } from "react";
import { useHistory } from "react-router-dom";
import Background from 'assets/img/Web.png';
import { Link  } from 'react-router-dom'

import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

const Fpage=()=> {

  var sectionStyle = {
    // width: "100%",
    // height: "1000000000000000000000000000000000000%",
    backgroundSize: 'cover', 
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${Background } )` 
  };
  

  return (
    <>

<section style={ sectionStyle }>

<container>
<Col md={{ span: 3, offset: 9 }}> 
<br></br>
<br></br>

<Row md={{ span: 100, offset: 9 }}>

<Link to=""  className="btn btn-primary w-10 mt-2">Transport Manager</Link>

<Link to="/login" className="btn btn-primary w-48 mt-2">Super Admin</Link>


</Row>

</Col>
</container>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>

 </section> 
        </>

        ) ;
    }
export default Fpage;